/**
 * The one key derivation for cross-row and cross-source identity comparisons
 * (duplicate detection, existing-member sets, Stelle grouping) — every
 * producer and consumer of such keys must build them through this, or sets
 * and lookups silently stop matching.
 */
export const normalizedKey = (value: string | undefined): string =>
  value?.trim().toLowerCase() ?? '';
